import moment from 'moment'
import { handleCureStatus, getStatusLabel } from '@/utils'
// 线上处方
const columnsToOnline = [
  {
    title: '就诊人姓名',
    dataIndex: 'patientProfileCommonVO',
    width: 120,
    key: 'patientProfileCommonVO',
    customRender: ({ text }) => {
      const { patientProfileName } = text || {}
      return patientProfileName || '--'
    }
  },
  {
    title: '诊断',
    dataIndex: 'diagnosisInfoList',
    width: 200,
    key: 'diagnosisInfoList',
    slots: { customRender: 'diagnosisInfoList' }
  },
  {
    title: '处方状态',
    width: 100,
    dataIndex: 'status',
    key: 'status',
    /**
     * 0：未购，1：已全部购买，2：待支付(产品要求把待支付改成已经购买)  3：已全部购买（部分购买） 4:已取消
     * NOTE:判断状态 已失效状态特殊处理
     *  未购买如果超时就是失效，未超时就是未购买
     *  已经购买如果取消就是取消，未取消就是已经购买
     */
    // 0：未购，1：已全部购买，2：已全部购买，3：部分购买, 4:已取消
    customRender: ({ text, record }) => {
      const status = ['未购买', '已全部购买', '已下单未支付', '已部分购买', '已取消']
      let ans = status[text]
      if (ans === '未购买') {
        ans = record.expire ? '已失效' : ans
      }
      return ans
    }
  },
  {
    title: '作废状态',
    width: 100,
    dataIndex: 'invalid',
    key: 'invalid',
    // 0未作废,1作废
    customRender: ({ text }) => {
      var status = ['未作废', '作废 ']
      return status[text]
    }
  },
  {
    title: '处方类型',
    width: 100,
    dataIndex: 'recomType',
    key: 'recomType',
    //  1西药 2中药
    customRender: ({ text }) => {
      var status = [null, '西药处方', '中药处方 ']
      return status[text]
    }
  },
  {
    title: '关联随访计划',
    dataIndex: 'followupPlanIds',
    key: 'followupPlanIds',
    width: 180,
    slots: { customRender: 'followupPlanIds' }
  },
  {
    title: '开方时间',
    width: 120,
    dataIndex: 'createdAt',
    key: 'createdAt'
  },
  {
    title: '治疗状态',
    width: 100,
    dataIndex: 'effectivenessResult',
    key: 'effectivenessResult',
    ellipsis: true,
    customRender: ({ text }) => {
      return handleCureStatus(text)
    }
  },
  {
    dataIndex: 'activityTemplateName',
    key: 'activityTemplateName',
    title: '临观活动名称',
    width: 180
  },
  {
    dataIndex: 'serialNumber',
    key: 'serialNumber',
    title: '处方ID',
    width: 180
  },
  {
    title: '所属互联网医院',
    width: 160,
    dataIndex: 'agencyName',
    key: 'agencyName',
    // 1海南 2桐庐
    customRender: ({ text }) => {
      // var status = [null, '海南互联网医院', '杭州桐庐施强互联网医院']
      // return status[text]
      return text || '--'
    }
  },
  {
    title: '判定时间',
    width: 120,
    dataIndex: 'determineTime',
    key: 'determineTime'
  },
  {
    title: '判定人',
    width: 150,
    dataIndex: 'determineName',
    key: 'determineName',
    ellipsis: true
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    width: 180,
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]
// 线下处方
const columnsToOffline = [
  {
    title: '就诊人姓名',
    dataIndex: 'patientProfileCommonVO',
    width: 120,
    key: 'patientProfileCommonVO',
    customRender: ({ text }) => {
      const { patientProfileName } = text || {}
      return patientProfileName || '--'
    }
  },
  {
    dataIndex: 'serialNumber',
    key: 'serialNumber',
    title: '处方ID',
    width: 180,
    ellipsis: true
  },
  {
    title: '临观活动名称',
    dataIndex: 'activityTemplateName',
    key: 'activityTemplateName',
    width: 180,
    ellipsis: true
  },
  {
    title: '关联随访计划',
    dataIndex: 'followupPlanIds',
    key: 'followupPlanIds',
    // ellipsis: true,
    width: 180,
    slots: { customRender: 'followupPlanIds' }
  },
  {
    title: '就诊诊断',
    dataIndex: 'diagnosisInfoList',
    key: 'diagnosisInfoList',
    width: 180,
    slots: { customRender: 'diagnosisInfoList' }
  },
  {
    title: '处方药品',
    dataIndex: 'MedicineList',
    key: 'MedicineList',
    slots: { customRender: 'MedicineList' },
    width: 180
  },
  {
    title: '用药周期(天)',
    dataIndex: 'medicineCycle',
    key: 'medicineCycle',
    width: 180,
    ellipsis: true
  },
  {
    title: '开始时间',
    dataIndex: 'purchaseTime',
    key: 'purchaseTime',
    ellipsis: true,
    width: 180,
    customRender: ({ text }) => {
      return moment(text).format('YYYY-MM-DD')
    }
  },
  {
    title: '结束时间',
    dataIndex: 'endDate',
    key: 'endDate',
    ellipsis: true,
    width: 180,
    customRender: ({ record }) => {
      if (!record.purchaseTime) return '--'
      return moment(record.purchaseTime).add(record.medicineCycle, 'days').format('YYYY-MM-DD')
    }
  },
  {
    title: '上传人',
    dataIndex: 'createdName',
    key: 'createdName',
    ellipsis: true,
    width: 180,
    customRender: ({ record }) => {
      const uploadType = ['系统', '患者', '医生', 'BD', '医生助手', '合作医院', 'cms', '医生学生']
      const type =
        record.uploadType || record.uploadType === 0 ? `${uploadType[record.uploadType]} - ` : ''
      return `${type}${record.createdName || '未知'}`
    }
  },
  {
    title: '上传时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    ellipsis: true,
    width: 180
  },
  {
    title: '操作',
    width: 180,
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]
//健康辅助方
const columnsToHealth = [
  {
    dataIndex: 'serialNumber',
    width: 180,
    key: 'serialNumber',
    title: '编号',
    ellipsis: true
  },
  {
    title: '就诊人姓名',
    dataIndex: 'patientName',
    width: 180,
    key: 'patientName',
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    title: '医生姓名',
    dataIndex: 'doctorName',
    width: 180,
    key: 'doctorName',
    ellipsis: true
  },
  {
    title: '处方状态',
    dataIndex: 'status',
    width: 180,
    key: 'status',
    // 0：未购，1：已全部购买，2：待支付，3：部分购买, 4:已取消
    customRender: ({ text, record }) => {
      const status = ['未购买', '已全部购买', '已下单未支付', '部分购买', '已取消', '已删除']
      let ans = status[text]
      if (ans === '未购买') {
        ans = record.expireStatus === 1 ? '已失效' : ans
      }
      return ans
    }
  },
  {
    title: '作废状态',
    width: 100,
    dataIndex: 'invalid',
    key: 'invalid',
    // 0未作废,1作废
    customRender: ({ text }) => {
      var status = ['未作废', '作废 ']
      return status[text]
    }
  },
  {
    title: '所属互联网医院',
    width: 180,
    dataIndex: 'agencyName',
    key: 'agencyName',
    customRender: ({ text }) => {
      // var status = [null, '海南互联网医院', '杭州桐庐施强互联网医院']
      // return status[text]
      return text || '--'
    }
  },
  {
    title: '开方时间',
    width: 180,
    dataIndex: 'createdAt',
    key: 'createdAt',
    ellipsis: true
  },
  {
    title: '操作',
    width: 180,
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]
//联合处方
const columnsGroup = [
  {
    title: '就诊人姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    width: 120,
    customRender: ({ record }) => {
      const { patientProfileName } = record.patientProfileCommonVO || {}
      const name = patientProfileName || '--'
      return record?.unionPrescriptionInnerType === 2 ? '待完善' : name
    }
  },
  {
    title: '诊断',
    dataIndex: 'westernDiagnosis',
    key: 'westernDiagnosis',
    width: 300,
    customRender: ({ text }) => {
      return (text && text.join('，')) || '--'
    }
  },
  {
    title: '医生',
    dataIndex: 'doctorName',
    key: 'doctorName',
    width: 100
  },
  {
    title: '处方类型',
    dataIndex: 'prescriptionTypeList',
    key: 'prescriptionTypeList',
    width: 180,
    customRender: ({ text }) => {
      return (text && text.join('，')) || '--'
    }
  },
  {
    title: '处方状态',
    dataIndex: 'prescriptionTypeList',
    key: 'prescriptionTypeList',
    width: 180,
    customRender: ({ record }) => {
      try {
        const { recommendStatus, recommendInvalid, expireStatus } = record || {}
        // const isExpire = moment(new Date()).isAfter(moment(recommendExpireAt))
        return getStatusLabel({
          status: recommendStatus,
          expire: expireStatus,
          invalid: recommendInvalid
        }).alt
      } catch (error) {
        return '--'
      }
    }
  },
  {
    title: '复诊日期',
    dataIndex: 'revisitTime',
    key: 'revisitTime',
    width: 180,
    customRender: ({ text, record }) => {
      return text ? text + (record.revisitType === 1 ? '（线上问诊）' : '（门诊就诊）') : '--'
    }
  },
  {
    title: '开方时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 180
  },
  {
    title: '操作',
    width: 180,
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]

// 处方下拉选 已购买=》全部购买 部分购买
// ?README: -1/全部 0/未购买,1/已购买,2/已失效,3/已取消,4/部分购买,5/已作废
//线上
const onLineOption = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 0,
    label: '未购买'
  },
  {
    value: 1,
    label: '全部购买'
  },
  {
    value: 4,
    label: '部分购买'
  },
  {
    value: 2,
    label: '已失效'
  },
  {
    value: 3,
    label: '已取消'
  },
  {
    value: 5,
    label: '已作废'
  }
]

const prescriptionOption = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 0,
    label: '未购买'
  },
  {
    value: 1,
    label: '全部购买'
  },
  {
    value: 4,
    label: '部分购买'
  },
  {
    value: 2,
    label: '已失效'
  },
  {
    value: 3,
    label: '已取消'
  }
]
// 辅助下拉选
const healthOption = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 0,
    label: '未购买'
  },
  {
    value: 1,
    label: '全部购买'
  },
  {
    value: 4,
    label: '部分购买'
  },
  {
    value: 2,
    label: '已取消'
  },
  {
    value: 6,
    label: '已作废'
  },
  {
    value: 7,
    label: '已失效'
  }
]
export {
  columnsToOnline,
  columnsToOffline,
  columnsToHealth,
  prescriptionOption,
  healthOption,
  columnsGroup,
  onLineOption
}
